// extracted by mini-css-extract-plugin
export default {"dropZoneBlock":"DropZone_dropZoneBlock__h9I1W","dropDownTitle":"DropZone_dropDownTitle__SguP8"};